import { OnRampWidget } from "./OnRampWidget";
import { PendoWidget } from "./PendoWidget";
import { StonlyWidget } from "./StonlyWidget";
import { NativeResourceCenterWidget } from "./NativeResourceCenterWidget";

export const widgets = [PendoWidget, StonlyWidget, OnRampWidget, NativeResourceCenterWidget];
